/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceEventProductUseService {
  /** @summary Get All */
  getAllServiceEventsServiceEventIdProductUsesGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetAllServiceEventsServiceEventIdProductUsesGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        options: {
          parameters: GetAllServiceEventsServiceEventIdProductUsesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    >;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
    ): ServiceOperationQueryKey<
      GetAllServiceEventsServiceEventIdProductUsesGetSchema,
      GetAllServiceEventsServiceEventIdProductUsesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllServiceEventsServiceEventIdProductUsesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllServiceEventsServiceEventIdProductUsesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllServiceEventsServiceEventIdProductUsesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllServiceEventsServiceEventIdProductUsesGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetAllServiceEventsServiceEventIdProductUsesGetSchema,
      GetAllServiceEventsServiceEventIdProductUsesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useInfiniteQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServiceEventsServiceEventIdProductUsesGetParameters,
      TQueryFnData = GetAllServiceEventsServiceEventIdProductUsesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServiceEventsServiceEventIdProductUsesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllServiceEventsServiceEventIdProductUsesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useInfiniteQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServiceEventsServiceEventIdProductUsesGetParameters,
      TQueryFnData = GetAllServiceEventsServiceEventIdProductUsesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServiceEventsServiceEventIdProductUsesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllServiceEventsServiceEventIdProductUsesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllServiceEventsServiceEventIdProductUsesGetTotal = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAllServiceEventsServiceEventIdProductUsesGetByParametersTotal = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllServiceEventsServiceEventIdProductUsesGetResults = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getAllServiceEventsServiceEventIdProductUsesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllServiceEventsServiceEventIdProductUsesGetCombinedResults = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getAllServiceEventsServiceEventIdProductUsesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllServiceEventsServiceEventIdProductUsesGetSchema,
          GetAllServiceEventsServiceEventIdProductUsesGetParameters,
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useSuspenseQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAllServiceEventsServiceEventIdProductUsesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllServiceEventsServiceEventIdProductUsesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useSuspenseInfiniteQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllServiceEventsServiceEventIdProductUsesGetParameters,
      TData = GetAllServiceEventsServiceEventIdProductUsesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError,
          OperationInfiniteData<TData, GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllServiceEventsServiceEventIdProductUsesGetParameters>,
      OperationError<GetAllServiceEventsServiceEventIdProductUsesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllServiceEventsServiceEventIdProductUsesGetData = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getAllServiceEventsServiceEventIdProductUsesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllServiceEventsServiceEventIdProductUsesGetCombinedData = qraft.serviceEventProductUseService.getAllServiceEventsServiceEventIdProductUsesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getAllServiceEventsServiceEventIdProductUsesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllServiceEventsServiceEventIdProductUsesGetSchema,
          GetAllServiceEventsServiceEventIdProductUsesGetParameters,
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetAllServiceEventsServiceEventIdProductUsesGetData,
              GetAllServiceEventsServiceEventIdProductUsesGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    ): Promise<GetAllServiceEventsServiceEventIdProductUsesGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    ): Promise<GetAllServiceEventsServiceEventIdProductUsesGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllServiceEventsServiceEventIdProductUsesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters
      >
    >;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllServiceEventsServiceEventIdProductUsesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllServiceEventsServiceEventIdProductUsesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters
      >
    >;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
    ): GetAllServiceEventsServiceEventIdProductUsesGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
    ):
      | OperationInfiniteData<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetParameters
        >
      | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllServiceEventsServiceEventIdProductUsesGetSchema,
              GetAllServiceEventsServiceEventIdProductUsesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetAllServiceEventsServiceEventIdProductUsesGetData,
                    GetAllServiceEventsServiceEventIdProductUsesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllServiceEventsServiceEventIdProductUsesGetSchema,
              GetAllServiceEventsServiceEventIdProductUsesGetParameters
            >,
            data: GetAllServiceEventsServiceEventIdProductUsesGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
    ):
      | QueryState<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >,
          GetAllServiceEventsServiceEventIdProductUsesGetError
        >
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
        | ServiceOperationQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >,
      updater: Updater<
        NoInfer<GetAllServiceEventsServiceEventIdProductUsesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllServiceEventsServiceEventIdProductUsesGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAllServiceEventsServiceEventIdProductUsesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetAllServiceEventsServiceEventIdProductUsesGetData,
              GetAllServiceEventsServiceEventIdProductUsesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetAllServiceEventsServiceEventIdProductUsesGetData,
                GetAllServiceEventsServiceEventIdProductUsesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetAllServiceEventsServiceEventIdProductUsesGetData,
          GetAllServiceEventsServiceEventIdProductUsesGetParameters
        >
      | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >,
      updater: Updater<
        NoInfer<GetAllServiceEventsServiceEventIdProductUsesGetData> | undefined,
        NoInfer<GetAllServiceEventsServiceEventIdProductUsesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllServiceEventsServiceEventIdProductUsesGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllServiceEventsServiceEventIdProductUsesGetSchema,
        GetAllServiceEventsServiceEventIdProductUsesGetData,
        TInfinite,
        GetAllServiceEventsServiceEventIdProductUsesGetParameters,
        GetAllServiceEventsServiceEventIdProductUsesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceEventsServiceEventIdProductUsesGetSchema,
            GetAllServiceEventsServiceEventIdProductUsesGetData,
            TInfinite,
            GetAllServiceEventsServiceEventIdProductUsesGetParameters,
            GetAllServiceEventsServiceEventIdProductUsesGetError
          >
    ): number;
    schema: GetAllServiceEventsServiceEventIdProductUsesGetSchema;
    types: {
      parameters: GetAllServiceEventsServiceEventIdProductUsesGetParameters;
      data: GetAllServiceEventsServiceEventIdProductUsesGetData;
      error: GetAllServiceEventsServiceEventIdProductUsesGetError;
    };
  };
  /** @summary Create */
  createServiceEventsServiceEventIdProductUsesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateServiceEventsServiceEventIdProductUsesPostBody,
        CreateServiceEventsServiceEventIdProductUsesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateServiceEventsServiceEventIdProductUsesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateServiceEventsServiceEventIdProductUsesPostBody,
          CreateServiceEventsServiceEventIdProductUsesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateServiceEventsServiceEventIdProductUsesPostData,
          CreateServiceEventsServiceEventIdProductUsesPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateServiceEventsServiceEventIdProductUsesPostData,
        CreateServiceEventsServiceEventIdProductUsesPostError
      >
    >;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateServiceEventsServiceEventIdProductUsesPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateServiceEventsServiceEventIdProductUsesPostSchema,
      CreateServiceEventsServiceEventIdProductUsesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CreateServiceEventsServiceEventIdProductUsesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServiceEventsServiceEventIdProductUsesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceEventsServiceEventIdProductUsesPostSchema,
        CreateServiceEventsServiceEventIdProductUsesPostData,
        CreateServiceEventsServiceEventIdProductUsesPostParameters,
        TVariables,
        OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServiceEventsServiceEventIdProductUsesPostData,
      OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateServiceEventsServiceEventIdProductUsesPostBody,
        CreateServiceEventsServiceEventIdProductUsesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceEventsServiceEventIdProductUsesPostSchema,
        CreateServiceEventsServiceEventIdProductUsesPostData,
        CreateServiceEventsServiceEventIdProductUsesPostParameters,
        TVariables,
        OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServiceEventsServiceEventIdProductUsesPostData,
      OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServiceEventsServiceEventIdProductUsesPostTotal = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServiceEventsServiceEventIdProductUsesPostTotal = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostParameters,
            OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventsServiceEventIdProductUsesPostSchema,
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostParameters,
            OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServiceEventsServiceEventIdProductUsesPostPendingMutationVariables = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServiceEventsServiceEventIdProductUsesPostMutationData = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServiceEventsServiceEventIdProductUsesPostData,
        OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
        MutationVariables<
          CreateServiceEventsServiceEventIdProductUsesPostBody,
          CreateServiceEventsServiceEventIdProductUsesPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostParameters,
            OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventsServiceEventIdProductUsesPostSchema,
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostParameters,
            OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServiceEventsServiceEventIdProductUsesPostData,
          OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
          MutationVariables<
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostParameters,
            OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceEventsServiceEventIdProductUsesPostSchema,
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostParameters,
            OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventProductUseService.createServiceEventsServiceEventIdProductUsesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServiceEventsServiceEventIdProductUsesPostBody,
              CreateServiceEventsServiceEventIdProductUsesPostData,
              CreateServiceEventsServiceEventIdProductUsesPostParameters,
              OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceEventsServiceEventIdProductUsesPostSchema,
              CreateServiceEventsServiceEventIdProductUsesPostBody,
              CreateServiceEventsServiceEventIdProductUsesPostData,
              CreateServiceEventsServiceEventIdProductUsesPostParameters,
              OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateServiceEventsServiceEventIdProductUsesPostData,
            CreateServiceEventsServiceEventIdProductUsesPostError,
            MutationVariables<
              CreateServiceEventsServiceEventIdProductUsesPostBody,
              CreateServiceEventsServiceEventIdProductUsesPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServiceEventsServiceEventIdProductUsesPostBody,
              CreateServiceEventsServiceEventIdProductUsesPostData,
              CreateServiceEventsServiceEventIdProductUsesPostParameters,
              OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceEventsServiceEventIdProductUsesPostSchema,
              CreateServiceEventsServiceEventIdProductUsesPostBody,
              CreateServiceEventsServiceEventIdProductUsesPostData,
              CreateServiceEventsServiceEventIdProductUsesPostParameters,
              OperationError<CreateServiceEventsServiceEventIdProductUsesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServiceEventsServiceEventIdProductUsesPostData,
          CreateServiceEventsServiceEventIdProductUsesPostError,
          MutationVariables<
            CreateServiceEventsServiceEventIdProductUsesPostBody,
            CreateServiceEventsServiceEventIdProductUsesPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateServiceEventsServiceEventIdProductUsesPostSchema;
    types: {
      parameters: CreateServiceEventsServiceEventIdProductUsesPostParameters;
      data: CreateServiceEventsServiceEventIdProductUsesPostData;
      error: CreateServiceEventsServiceEventIdProductUsesPostError;
      body: CreateServiceEventsServiceEventIdProductUsesPostBody;
    };
  };
  /** @summary Update */
  updateServiceEventsServiceEventIdProductUsesProductUseIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError
      >
    >;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
      UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useMutation({
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
      OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useMutation({
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
      OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServiceEventsServiceEventIdProductUsesProductUseIdPatchTotal = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServiceEventsServiceEventIdProductUsesProductUseIdPatchTotal = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId,
     *             product_use_id: productUseId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
            OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
            OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServiceEventsServiceEventIdProductUsesProductUseIdPatchPendingMutationVariables = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServiceEventsServiceEventIdProductUsesProductUseIdPatchMutationData = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId,
     *                 product_use_id: productUseId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
        OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
        MutationVariables<
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
            OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
            OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
          OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
          MutationVariables<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
            OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
            OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId,
     *             product_use_id: productUseId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventProductUseService.updateServiceEventsServiceEventIdProductUsesProductUseIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
              OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
              OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError,
            MutationVariables<
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
              OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
              UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters,
              OperationError<UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData,
          UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError,
          MutationVariables<
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody,
            UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema;
    types: {
      parameters: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters;
      data: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData;
      error: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError;
      body: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody;
    };
  };
  /** @summary Delete */
  deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError
      >
    >;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
      DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useMutation({
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
        TVariables,
        OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
      OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useMutation({
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId,
     *         product_use_id: productUseId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
        TVariables,
        OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
      OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteTotal = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteTotal = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId,
     *             product_use_id: productUseId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
            OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
            OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteServiceEventsServiceEventIdProductUsesProductUseIdDeletePendingMutationVariables = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteMutationData = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId,
     *                 product_use_id: productUseId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
        OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
        MutationVariables<
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
            OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
            OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
          OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
          MutationVariables<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
            OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
            OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId,
     *             product_use_id: productUseId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceEventProductUseService.deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
              OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
              OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError,
            MutationVariables<
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
              OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
              DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters,
              OperationError<DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData,
          DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError,
          MutationVariables<
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody,
            DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema;
    types: {
      parameters: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters;
      data: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData;
      error: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError;
      body: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllServiceEventsServiceEventIdProductUsesGet = {
  schema: {
    method: 'get',
    url: '/service_events/{service_event_id}/product_uses',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllServiceEventsServiceEventIdProductUsesGetSchema;
  [QraftServiceOperationsToken]: ServiceEventProductUseService['getAllServiceEventsServiceEventIdProductUsesGet'];
};
/** @summary Create */
export const createServiceEventsServiceEventIdProductUsesPost = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/product_uses',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServiceEventsServiceEventIdProductUsesPostSchema;
  [QraftServiceOperationsToken]: ServiceEventProductUseService['createServiceEventsServiceEventIdProductUsesPost'];
};
/** @summary Update */
export const updateServiceEventsServiceEventIdProductUsesProductUseIdPatch = {
  schema: {
    method: 'patch',
    url: '/service_events/{service_event_id}/product_uses/{product_use_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema;
  [QraftServiceOperationsToken]: ServiceEventProductUseService['updateServiceEventsServiceEventIdProductUsesProductUseIdPatch'];
};
/** @summary Delete */
export const deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete = {
  schema: {
    method: 'delete',
    url: '/service_events/{service_event_id}/product_uses/{product_use_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema;
  [QraftServiceOperationsToken]: ServiceEventProductUseService['deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete'];
};
export const serviceEventProductUseService = {
  getAllServiceEventsServiceEventIdProductUsesGet,
  createServiceEventsServiceEventIdProductUsesPost,
  updateServiceEventsServiceEventIdProductUsesProductUseIdPatch,
  deleteServiceEventsServiceEventIdProductUsesProductUseIdDelete,
} as const;
type GetAllServiceEventsServiceEventIdProductUsesGetSchema = {
  method: 'get';
  url: '/service_events/{service_event_id}/product_uses';
  security: ['HTTPBearer'];
};
type GetAllServiceEventsServiceEventIdProductUsesGetParameters =
  paths['/service_events/{service_event_id}/product_uses']['get']['parameters'];
type GetAllServiceEventsServiceEventIdProductUsesGetData =
  paths['/service_events/{service_event_id}/product_uses']['get']['responses']['200']['content']['application/json'];
type GetAllServiceEventsServiceEventIdProductUsesGetError =
  paths['/service_events/{service_event_id}/product_uses']['get']['responses']['422']['content']['application/json'];
type CreateServiceEventsServiceEventIdProductUsesPostSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/product_uses';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServiceEventsServiceEventIdProductUsesPostParameters =
  paths['/service_events/{service_event_id}/product_uses']['post']['parameters'];
type CreateServiceEventsServiceEventIdProductUsesPostData =
  paths['/service_events/{service_event_id}/product_uses']['post']['responses']['200']['content']['application/json'];
type CreateServiceEventsServiceEventIdProductUsesPostError =
  paths['/service_events/{service_event_id}/product_uses']['post']['responses']['422']['content']['application/json'];
type CreateServiceEventsServiceEventIdProductUsesPostBody =
  paths['/service_events/{service_event_id}/product_uses']['post']['requestBody']['content']['application/json'];
type UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchSchema = {
  method: 'patch';
  url: '/service_events/{service_event_id}/product_uses/{product_use_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchParameters =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['patch']['parameters'];
type UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchData =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchError =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServiceEventsServiceEventIdProductUsesProductUseIdPatchBody =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['patch']['requestBody']['content']['application/json'];
type DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteSchema = {
  method: 'delete';
  url: '/service_events/{service_event_id}/product_uses/{product_use_id}';
  security: ['HTTPBearer'];
};
type DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteParameters =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['delete']['parameters'];
type DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteData =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['delete']['responses']['200']['content']['application/json'];
type DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteError =
  paths['/service_events/{service_event_id}/product_uses/{product_use_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteServiceEventsServiceEventIdProductUsesProductUseIdDeleteBody = undefined;
